import './index.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Form } from 'antd';

export default TravelHistory; function TravelHistory({ HandleTravelDateChange, TaxFilingQuestionnaire, HandleTaxFilingQuestionnaireSave }) {
    const { t } = useTranslation();
    const [travelDate, setTravelDate] = useState([{ id: 1, recID: '', taxFilingDetailRecID: '', fromDate: '', toDate: '', totalDays: 0 }]);
    const [total, setTotal] = useState({ travelDays: 0, SPTDays: 0, periodStayCurrentYear: 0, periodStayLastYear: 0, periodStayLast2Years: 0 });

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
    const dd = String(currentDate.getDate()).padStart(2, "0");
    const maxDate = `${yyyy}-${mm}-${dd}`;

    const minDate = `${TaxFilingQuestionnaire.TaxFilingYear - 3}-01-01`;

    const FormItem = Form.Item;
    const formRef = Form.useFormInstance();
    const viewOnly = TaxFilingQuestionnaire?.Status?.toLowerCase() !== '' && TaxFilingQuestionnaire?.Status?.toLowerCase() !== 'new';
    const MS_PER_DAY = 24 * 60 * 60 * 1000;

    function daysBetween(start, end) {
        const daysPerYear = getDaysPerYear(start, end);
        return Object.values(daysPerYear).reduce((sum, days) => sum + days, 0);
    }



    function getDaysPerYear(startDate, endDate) {
        const result = {};
        const start = new Date(startDate);
        const end = new Date(endDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        const endExclusive = new Date(end.getTime() + MS_PER_DAY);

        const startYear = start.getFullYear();
        const endYear = end.getFullYear();

        for (let year = startYear; year <= endYear; year++) {
            const yearStart = new Date(year, 0, 1);
            const yearEndExclusive = new Date(year + 1, 0, 1);
            const rangeStart = new Date(Math.max(start.getTime(), yearStart.getTime()));
            const rangeEnd = new Date(Math.min(endExclusive.getTime(), yearEndExclusive.getTime()));

            if (rangeEnd > rangeStart) {
                const days = (rangeEnd - rangeStart) / (MS_PER_DAY);
                result[year] = days;
            }
        }
        return result;
    }

    const handleChangeTravelDate = async (id, key, value) => {
        setTravelDate(prev =>
            prev.map(input =>
                input.id === id ? { ...input, [key]: value, totalDays: key === 'toDate' ? daysBetween(input.fromDate, value) : daysBetween(value, input.toDate) } : input
            )
        );
    }

    const handleRemoveTravelDate = async (id) => {
        setTravelDate(prev => prev.filter(input => input.id !== id));
    };

    const handleAddTravelDate = async () => {
        const newId = Math.max(...travelDate.map(i => i.id)) + 1;
        setTravelDate(prev => [...prev, { id: travelDate.length > 0 ? newId : 1, fromDate: '', toDate: '', totalDays: 0 }]);
    };

    useEffect(() => {
        if (formRef.getFieldValue('VisitedUSPast3Years') === 'Yes') {
            travelDateUpdate();
        }
        else {
            setTotal(prevData => ({
                ...prevData,
                periodStayCurrentYear: 0,
                periodStayLastYear: 0,
                periodStayLast2Years: 0,
                SPTDays: 0
            }));
        }
    }, [travelDate])


    const travelDateUpdate = async () => {
        const travel = travelDate
            .map(o => Number(o?.['totalDays']))
            .filter(Number.isFinite)
            .reduce((a, b) => a + b, 0);

        let currentYear = 0;
        let totalDaysLastYear = 0;
        let totalDaysLast2Years = 0;

        travelDate?.map((item) => {
            const year = getDaysPerYear(item.fromDate, item.toDate);
            currentYear = currentYear + (year[TaxFilingQuestionnaire.TaxFilingYear] ?? 0);
            totalDaysLastYear = totalDaysLastYear + (year[TaxFilingQuestionnaire.TaxFilingYear - 1] ?? 0);
            totalDaysLast2Years = totalDaysLast2Years + (year[TaxFilingQuestionnaire.TaxFilingYear - 2] ?? 0);
        });

        const spt = currentYear + (totalDaysLastYear / 3) + (totalDaysLast2Years / 6);
        setTotal(prevData => ({
            ...prevData,
            travelDays: travel,
            SPTDays: spt.toFixed(2),
            periodStayCurrentYear: currentYear,
            periodStayLastYear: totalDaysLastYear,
            periodStayLast2Years: totalDaysLast2Years
        }));
    }


    const handleFast3Years = async (value) => {
        if (value === 'Yes') {
            travelDateUpdate();
        }
        else {
            setTotal(prevData => ({
                ...prevData,
                periodStayCurrentYear: 0,
                periodStayLastYear: 0,
                periodStayLast2Years: 0,
                SPTDays: 0
            }));
        }
    }



    useEffect(() => {
        const validTravelDates = travelDate.filter(x => Number.isFinite(x.totalDays) && x.totalDays > 0).map(x => ({
            FromDate: x.fromDate,
            ToDate: x.toDate,
            TaxFilingDetailRecID: formRef.getFieldValue('RecId')
        }));
        formRef.setFieldValue('USStays', validTravelDates);
        HandleTravelDateChange(total, validTravelDates);
    }, [total])

    const usStays = async () => {
        const stay = TaxFilingQuestionnaire.USStays;
        const newTravelDate = [];
        let id = 1;

        stay.map((item) => {
            newTravelDate.push({
                id: id,
                fromDate: formatDate(new Date(item.FromDate)),
                toDate: formatDate(new Date(item.ToDate)),
                totalDays: daysBetween(item.FromDate, item.ToDate),
                recID: item.RecID,
                taxFilingDetailRecID: item.TaxFilingDetailRecID
            });
            id = id + 1;
        });
        setTravelDate(newTravelDate);
    }

    useEffect(() => {
        usStays();
    }, []);

    const formatDate = (value) =>
        new Intl.DateTimeFormat('fr-CA', {
            year: 'numeric', month: '2-digit', day: '2-digit'

        }).format(value);


    return (
        <>
            <div id='stepper-non-us-questionnaire-div'>
                <div className='row tax-filing-questionnaire-title'>
                    <p>
                        {t('TRAVEL HISTORY')}
                    </p>
                </div>
                <div className='row stepper-non-us-questionnaire-content'>
                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 travel-history-details'>
                            <div className='detail-title col-md-8'>{t('Have you ever applied for a U.S. Green Card?')}<i className='required'>*</i></div>
                            <div className='details col-md-4'>
                                <FormItem
                                    name="AppliedForGreenCard"
                                    rules={[{ required: true, message: t('This field is required') }]}
                                >
                                    <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('AppliedForGreenCard', e.target.value)}>
                                        <option value=''></option>
                                        <option value='Yes'>{t('Yes')}</option>
                                        <option value='No'>{t('No')}</option>
                                    </select>
                                </FormItem>

                            </div>
                        </div>
                    </div>
                    {
                        formRef?.getFieldValue('AppliedForGreenCard') === 'Yes' && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-7 tab'>{t('Do you have an active Green Card application?')}<i className='required'>*</i></div>
                                    <div className='details col-md-5'>
                                        <FormItem
                                            name="ActiveGreenCardApplication"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('ActiveGreenCardApplication', e.target.value)}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>

                                    </div>
                                </div>
                            </div>
                        </>)
                    }

                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 travel-history-details'>
                            <div className='detail-title col-md-8'>{t('Have you ever been a Green Card Holder?')}<i className='required'>*</i></div>
                            <div className='details col-md-4'>
                                <FormItem
                                    name="BeenGreenCardHolder"
                                    rules={[{ required: true, message: t('This field is required') }]}
                                >
                                    <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('BeenGreenCardHolder', e.target.value)}>
                                        <option value=''></option>
                                        <option value='Yes'>{t('Yes')}</option>
                                        <option value='No'>{t('No')}</option>
                                    </select>
                                </FormItem>
                            </div>
                        </div>
                    </div>

                    {
                        formRef?.getFieldValue('BeenGreenCardHolder') === 'Yes' && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-7 tab'>{t('Are you currently a Green Card Holder?')}<i className='required'>*</i></div>
                                    <div className='details col-md-5'>
                                        <FormItem
                                            name="ActiveGreenCardHolder"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('ActiveGreenCardHolder', e.target.value)}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            {
                                formRef?.getFieldValue('ActiveGreenCardHolder') === 'No' && (<>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab'>{t('If No, please indicate the date and reason of when you surrendered your US Green Card')}:<i className='required'>*</i></div>
                                            <div className='details col-md-5'>
                                                <FormItem
                                                    name="GreenCardCancellationReason"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <textarea disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('GreenCardCancellationReason', e.target.value)}></textarea>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </>)
                            }
                        </>)
                    }

                    {
                        (formRef?.getFieldValue('ActiveGreenCardHolder') === 'No' || formRef?.getFieldValue('ActiveGreenCardHolder') === '') && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-8'>{t('Have you ever been a U.S. citizen?')}<i className='required'>*</i></div>
                                    <div className='details col-md-4'>
                                        <FormItem
                                            name="BeenUSCitizen"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('BeenUSCitizen', e.target.value)}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                            {
                                formRef?.getFieldValue('BeenUSCitizen') === 'Yes' && (<>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab'>{t('Are you currently a US citizen?')}<i className='required'>*</i></div>
                                            <div className='details col-md-5'>
                                                <FormItem
                                                    name="ActiveUSCitizen"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('ActiveUSCitizen', e.target.value)}>
                                                        <option value=''></option>
                                                        <option value='Yes'>{t('Yes')}</option>
                                                        <option value='No'>{t('No')}</option>
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        formRef?.getFieldValue('ActiveUSCitizen') === 'No' && (<>
                                            <div className='col-md-12 row input-row'>
                                                <div className='col-md-9 travel-history-details'>
                                                    <div className='detail-title col-md-7 tab'>{t('If No, please indicate the date and reason of your U.S. citizenship renunciation')}:<i className='required'>*</i> </div>
                                                    <div className='details col-md-5'>
                                                        <FormItem
                                                            name="USCitizenshipCancellationReason"
                                                            rules={[{ required: true, message: t('This field is required') }]}
                                                        >
                                                            <textarea disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('USCitizenshipCancellationReason', e.target.value)}></textarea>

                                                        </FormItem>
                                                    </div>
                                                </div>
                                            </div>
                                        </>)
                                    }
                                </>)
                            }

                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-8'>{t('Have you ever changed your visa type or U.S. immigration status?')}<i className='required'>*</i></div>
                                    <div className='details col-md-4'>
                                        <FormItem
                                            name="ChangedUSStatusOrVisaType"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('ChangedUSStatusOrVisaType', e.target.value)}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            {
                                formRef?.getFieldValue('ChangedUSStatusOrVisaType') === 'Yes' && (<>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab'>{t('If Yes, please indicate the date and the nature of change')}:<i className='required'>*</i> </div>
                                            <div className='details col-md-5'>
                                                <FormItem
                                                    name="ChangedVisaTypeReason"
                                                    rules={[{ required: formRef?.getFieldValue('ChangedUSStatusOrVisaType') === 'Yes' ? true : false, message: t('This field is required') }]}
                                                >
                                                    <textarea disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('ChangedVisaTypeReason', e.target.value)}></textarea>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </>)
                            }

                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-8'> {t('If you had a visa on the previous tax filing year, provide the visa type (B-1, B-2, etc.)')}<i className='required'>*</i></div>
                                    <div className='details col-md-4'>
                                        <FormItem
                                            name="USVisaTypesCurrentYear"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <input type='text' disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('USVisaTypesCurrentYear', e.target.value)} />
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-8'>{t('Have you filed a U.S. Tax return before?')}<i className='required'>*</i></div>
                                    <div className='details col-md-4'>
                                        <FormItem
                                            name="FiledUSTaxBefore"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('FiledUSTaxBefore', e.target.value)}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            {
                                formRef?.getFieldValue('FiledUSTaxBefore') === 'Yes' && (<>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab'>{t('FileUSTaxBefore').replace('{previousYear}', sessionStorage.getItem('taxYear') - 1)}:<i className='required'>*</i></div>
                                            <div className='details col-md-5'>
                                                <FormItem
                                                    name="FiledUSTaxForms"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <textarea disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('FiledUSTaxForms', e.target.value)}></textarea>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </>)
                            }

                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 travel-history-details'>
                                    <div className='detail-title col-md-8'>{t('Have you traveled to the US for the past three years?')}<i className='required'>*</i></div>
                                    <div className='details col-md-4'>
                                        <FormItem
                                            name="VisitedUSPast3Years"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => { HandleTaxFilingQuestionnaireSave('VisitedUSPast3Years', e.target.value); handleFast3Years(e.target.value); }}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            {
                                formRef?.getFieldValue('VisitedUSPast3Years') === 'Yes' && (<>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab'>{t('If Yes, please provide')}:</div>
                                            <div className='details col-md-5'>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab'>
                                                <table className='tab'>
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                {t('Arrival')}
                                                            </th>
                                                            <th>
                                                                {t('Departure')}
                                                            </th>
                                                            <th>
                                                                {t('Action')}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            travelDate.map((input) => (
                                                                <tr>
                                                                    <td>
                                                                        <input disabled={viewOnly} type="date" class="form-control" placeholder={t('From')} value={input.fromDate}
                                                                            min={minDate}
                                                                            max={input.toDate !== '' ? input.toDate : maxDate} onChange={(e) => handleChangeTravelDate(input.id, 'fromDate', e.target.value)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="date" class="form-control" placeholder={t('To')} value={input.toDate} min={input.fromDate} max={maxDate} onChange={(e) => handleChangeTravelDate(input.id, 'toDate', e.target.value)} disabled={viewOnly ? true : input.fromDate === ''} />
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            !viewOnly && (<>
                                                                                <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { handleRemoveTravelDate(input.id) }}>
                                                                                    <path d="M2.8077 16.8846C2.31058 16.8846 1.88502 16.7075 1.53102 16.3535C1.17701 15.9995 1 15.574 1 15.0769V2.38458H0.75C0.5375 2.38458 0.359375 2.31267 0.215625 2.16885C0.071875 2.02505 0 1.84685 0 1.63425C0 1.42167 0.071875 1.24358 0.215625 1.1C0.359375 0.9564 0.5375 0.884599 0.75 0.884599H4.49997C4.49997 0.639733 4.58619 0.431084 4.75863 0.25865C4.93106 0.0862169 5.13971 0 5.38457 0H9.61538C9.86024 0 10.0689 0.0862169 10.2413 0.25865C10.4138 0.431084 10.5 0.639733 10.5 0.884599H14.25C14.4625 0.884599 14.6406 0.956508 14.7843 1.10033C14.9281 1.24414 15 1.42234 15 1.63492C15 1.84752 14.9281 2.02562 14.7843 2.1692C14.6406 2.31278 14.4625 2.38458 14.25 2.38458H14V15.0769C14 15.574 13.8229 15.9995 13.4689 16.3535C13.1149 16.7075 12.6894 16.8846 12.1922 16.8846H2.8077ZM12.5 2.38458H2.49997V15.0769C2.49997 15.1666 2.52883 15.2403 2.58652 15.298C2.64422 15.3557 2.71795 15.3846 2.8077 15.3846H12.1922C12.282 15.3846 12.3557 15.3557 12.4134 15.298C12.4711 15.2403 12.5 15.1666 12.5 15.0769V2.38458ZM5.65417 13.3846C5.86676 13.3846 6.04484 13.3127 6.18842 13.169C6.33202 13.0252 6.40382 12.8471 6.40382 12.6346V5.13455C6.40382 4.92207 6.33192 4.74395 6.1881 4.6002C6.04428 4.45645 5.86608 4.38458 5.6535 4.38458C5.4409 4.38458 5.26281 4.45645 5.11922 4.6002C4.97564 4.74395 4.90385 4.92207 4.90385 5.13455V12.6346C4.90385 12.8471 4.97576 13.0252 5.11958 13.169C5.26337 13.3127 5.44158 13.3846 5.65417 13.3846ZM9.34645 13.3846C9.55905 13.3846 9.73714 13.3127 9.88072 13.169C10.0243 13.0252 10.0961 12.8471 10.0961 12.6346V5.13455C10.0961 4.92207 10.0242 4.74395 9.88037 4.6002C9.73658 4.45645 9.55837 4.38458 9.34577 4.38458C9.13319 4.38458 8.95511 4.45645 8.81152 4.6002C8.66792 4.74395 8.59613 4.92207 8.59613 5.13455V12.6346C8.59613 12.8471 8.66803 13.0252 8.81185 13.169C8.95567 13.3127 9.13387 13.3846 9.34645 13.3846Z" fill="#003448" />
                                                                                </svg>
                                                                            </>)
                                                                        }

                                                                        &nbsp; {input.totalDays.toString() === 'NaN' ? 0 : input.totalDays} {input.totalDays !== 1 ? t('Days') : t('Day')}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 travel-history-details'>
                                            <div className='detail-title col-md-7 tab travel-history-notes'>
                                                <span>{t('Please note that any part of a day spent in the United States is counted as one full day.')}</span>
                                                <br />
                                                <span className='total-days-notes'>{t('Total Number of Days Spent in the U.S. in the past 3 years')}:</span> <span className='total-days'>{total.travelDays} {total.travelDays === 1 ? t('Day') : t('Days')}</span>
                                                <br />
                                                <span className='total-days-notes'>{t('Total SPT Days in the past 3 years')}:</span> <span className='total-days'>{total.SPTDays} {total.SPTDays === 1 ? t('Day') : t('Days')}</span>
                                            </div>
                                            {
                                                !viewOnly && (<>
                                                    <div className='details col-md-3 add-button'>
                                                        <button onClick={() => handleAddTravelDate()}>{t('Add Travel Dates')}</button>
                                                    </div>
                                                </>)
                                            }
                                        </div>
                                    </div>
                                </>)
                            }
                        </>)
                    }

                    {
                        (total.SPTDays > 183 || (formRef?.getFieldValue('ActiveGreenCardHolder') === 'Yes')) && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-12 us-tax-resident-icons'>
                                    <svg
                                        className="svg-circle"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                            fill="#dd0606"
                                        />
                                    </svg>
                                    <svg
                                        className="svg-exclamation"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="2"
                                        height="10"
                                        viewBox="0 0 2 10"
                                        fill="none"
                                    >
                                        <path
                                            d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                            fill="#dd0606"
                                        />
                                        <path
                                            d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                            fill="#dd0606"
                                        />
                                    </svg>
                                </div>
                                <div className='us-tax-resident-notes'>
                                    <span>
                                        {t('You are not eligible to proceed with AAS services, which are for non-U.S. tax residents only.')}
                                    </span>
                                </div>
                            </div>
                        </>)
                    }
                </div>
            </div>
        </>
    );
}